import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Color } from '../../lib/types.ts';
import { ColorVariants } from './SubCategoryCard.tsx';

interface LastPlayedLectureCardProps {
    color: Color;
    heading: string | React.ReactNode;
    subheading: string | React.ReactNode;
    poster?: string;
    href: string;
    children?: React.ReactNode;
}

export default function LastPlayedLectureCard({
    color,
    href,
    heading,
    subheading,
    children,
    poster,
}: LastPlayedLectureCardProps) {
    return (
        <div>
            <Link to={href}>
                <div className="min-h-64 w-[248px] rounded-3xl bg-white shadow-sm transition-shadow hover:shadow-md">
                    <div
                        className={clsx(
                            'flex h-full w-full flex-col items-center rounded-xl p-4 pt-0',
                            'min-h-64',
                            'bg-gradient-to-b',
                            ColorVariants[color].card
                        )}
                    >
                        <div
                            className={clsx(
                                'h-1 w-full flex-shrink-0 rounded-b-md',
                                ColorVariants[color].bar
                            )}
                        />
                        <div className="my-4 h-32 w-full">
                            {poster ? (
                                <img
                                    loading="lazy"
                                    src={poster}
                                    className="relative h-full w-full rounded-md object-cover object-center"
                                />
                            ) : (
                                <div className="h-full w-full rounded-md bg-black/10" />
                            )}

                            {children}
                        </div>
                        <p className="mb-2 text-center font-normal text-ink-800">
                            {subheading}
                        </p>
                        <h5 className="text-center">{heading}</h5>
                    </div>
                </div>
            </Link>
        </div>
    );
}
